export default t => [
	{
		Header: t('options_section.fields.description'),
		accessor: 'description'
	}, {
		Header: t('common.fields.type'),
		accessor: 'type',
		Cell: ({ original }) => original?.type === 'income' ? t('options_section.strings.income') : t('options_section.strings.outcome')
	}
]
